<input type="text" matInput [formControl]="control" [matAutocomplete]="auto" placeholder="Filtre"
  (keydown.space)="$event.stopPropagation()">

<mat-autocomplete #auto="matAutocomplete">
  <mat-option *ngFor="let item of filteredList | async" [value]="item[valueWanted]">
    {{ item.display }}
  </mat-option>
</mat-autocomplete>